/* ========================================================================
    Module: Visibility
 ========================================================================== */
type FormElement =
    | HTMLInputElement
    | HTMLSelectElement
    | HTMLTextAreaElement
    | HTMLButtonElement;

const toggleRadioVisibility = (): void => {
    const VISIBLE_VALUE = "1";
    const radioGroups: Record<string, HTMLInputElement[]> = {};

    // 各ラジオボタンごとにグループ化する
    document
        .querySelectorAll<HTMLInputElement>(
            '.js-visibility-toggle[type="radio"]',
        )
        .forEach((toggle) => {
            if (!toggle.name) return;
            if (!radioGroups[toggle.name]) radioGroups[toggle.name] = [];

            radioGroups[toggle.name].push(toggle);
        });

    // 各ラジオボタングループごとに初期表示と change イベントを登録する
    Object.values(radioGroups).forEach((group) => {
        const targetSelector = group[0].dataset.visibilityTarget;
        if (!targetSelector) return;

        const targets = document.querySelectorAll<HTMLElement>(targetSelector);

        const updateVisibility = () => {
            const shouldShow = group.some(
                (t) => t.checked && t.value === VISIBLE_VALUE,
            );
            targets.forEach((target) => itemVisibility(target, shouldShow));
        };

        group.forEach((t) => t.addEventListener("change", updateVisibility));

        updateVisibility();
    });
};

const itemVisibility = (target: HTMLElement, isVisible: boolean): void => {
    target.classList.toggle("is-hidden", !isVisible);
    target
        .querySelectorAll<FormElement>("input, select, textarea, button")
        .forEach((f) => (f.disabled = !isVisible));
};

export { toggleRadioVisibility };
